import { ICommissionRate } from '@app/shared/types';
import { chain, toLower } from 'lodash';

export const sortedCommissionRates = (
  commissionRates: ICommissionRate[],
): ICommissionRate[] => {
  return chain(commissionRates)
    .sortBy((rate) => toLower(rate.name))
    .sortBy((rate) => (rate.is_primary ? 0 : 1))
    .value();
};
